export const URLS = {
  GET_POLYGONS: "/V2/19/delivery_area_fencing",
  GET_AREAS: "/V2/19/GetDeliveryArea",
  LOG_BUTTON_CLICK: "api/log_button_click",
  UPLOAD_IMAGE: "upload_file/",
  LOGIN_SEND_OTP: '/Store/2/LoginPhoneSentOtp',
  LOGIN_VERIFY_OTP: '/Store/2/LoginPhoneVerifyOtp',
  GET_LOGIN_DATA: "/Store/2/LoginWithPhone",
  GET_LOGIN_RETAILERS: "/Store/2/GetAssociatedRetailersWithUsers",

  // Master Store APIs Odoo
  GET_SUB_STORE: "/Store/3/GetSubStores",
  SEARCH_SUBSTORE_INVENTORY: "/Store/2/StockSearchProduct",
  CREATE_STOCK_TRANSFER: "/Store/2/CreateStockTransferInternal",
  GET_STOCK_REPORT: "/Store/2/GetStockTransferInternalReport",
  GET_STOCK_SUMMARY_EXCEL: "/Store/2/GetStockTransferInternalReportExcel",
  CREATE_SUB_STORE: "/Store/2/CreateStoreBranch",
  DELETE_STORE_BRANCH: "/Store/2/DeleteStoreBranch",
  DEACTIVATE_STORE_BRANCH: "/Store/2/DeactivateStoreBranch",
  ACTIVATE_STORE_BRANCH: "/Store/2/ActivateStoreBranch",
  GET_SUB_STORE_DATA: "/Store/2/GetStoreBranchDetails",
  UPDATE_SUBSTORE_DATA: "/Store/2/UpdateStoreBranch",
  VERIFY_BRANCH_DATA: "/Store/2/VerifySubStoreDetails",
  GET_STOCK_ORDER_LINES: "/Store/2/GetStockTransferLines",
  CANCEL_STOCK_TRANSFER: "/Store/2/ConfirmStockTransferInternal",
  VERIFY_WAREHOUSE_DATA: "/Store/2/VerifyWarehouseDetails",
  CREATE_WAREHOUSE_STORE: "/Store/2/CreateWarehouse",
  UPDATE_WAREHOUSE_DATA: "/Store/2/UpdateWarehouse",
  GET_WAREHOUSE_DATA: "/Store/2/GetWarehouseDetails",
  ACTIVATE_WAREHOUSE: "/Store/2/ActivateWarehouse",
  DEACTIVATE_WAREHOUSE: "/Store/2/DeactivateWarehouse",


  // Money Transfer APIs Odoo 
  CREATE_MONEY_TRANSFER: "/Store/2/CreateMoneyTransfer",
  GET_MONEY_TRANSFER: "/Store/2/GetMoneyTransfer",
  EDIT_MONEY_TRANSFER: "/Store/2/EditMoneyTransfer",
  GET_MONEY_TRANSFER_EXCEL: "/Store/2/GetMoneyTransferExcel",
  GET_BALANCE: "/Store/2/GetTransferBalance",
  TRANSFER_FROM_BANKS: '/Store/2/GetMoneyTransferFromType',
  TRANSFER_TO_BANKS: '/Store/2/GetMoneyTransferToType',
  DEPOSIT_PAYMENT_METHODS: "/Store/2/GetDepositPaymentMethod",
  DEPOSIT_PAYMENT_METHOD_BALANCE: "/Store/2/GetDepositPaymentMethodBalance",
  CREATE_DEPOSIT_ENTRY: "/Store/2/CreateDepositEntry",

  // New Inventory APIs Odoo
  GET_INVENTORY_DASHBOARD: "/Store/2/GetInventoryDashboard",
  GET_ALL_PRODUCTS: "/Store/2/GetInstantStockDetails",
  GET_RETAILER_PRODUCT_CATEGORY: "/Store/2/GetCategories",
  GET_INCOMPLETE_PRODUCTS: "/Store/2/GetSalesCostPriceProducts",
  UPDATE_STORE_PRODUCT_DETAIL: "/Store/2/InstantStockUpdate",
  UPDATE_STORE_INCOMPLETE_PRODUCT_DETAIL: "/Store/2/AddSalesCostPrice",
  SEARCH_INVENTORY_ONBOARD: "Store/2/ScanBarcode",
  ADD_PRODUCT: "Store/2/AddProduct",
  GET_UOM: "Store/2/GetUoms",
  PRODUCT_REQUEST: "/Store/2/ProductRequest",
  UPDATE_GS_PRODUCT_REQUEST: "/update_gs_product_request",
  UPLOAD_BULK_INVENTORY: "/UploadBulkInventory",
  UPLOAD_BULK_INVENTORY_NEW: "Store/2/RequestUploadBulkInventory",
  UPLOAD_BULK_INVENTORY_NEW_LOOSE: "Store/2/RequestUploadBulkInventoryLoose",
  GET_OUT_LOW_HIGH: "/Store/2/GetInstantStockDetailsOutofStock",
  GET_PROD_INFO: "/Store/2/GetProductInformation",
  GET_PROD_PURCHASE_DATA: "/Store/2/GetProductPurchaseInformation",
  GET_PROD_SALE_PURCHASE_DATA: "/Store/2/GetProductSalePurchaseInfo",
  GET_PURCHASE_INFO: "/Store/2/PurchaseDashboard",
  GET_PROD_SALE_DATA: "/Store/2/GetProductSalesInformation",
  EXPORT_INVENTORY: "/Store/2/DowloadAllInventory",
  GET_PRODUCT_PACKAGE: "/Store/2/GetProductPackages",
  UPDATE_PRODUCT_PACKAGE: "/Store/2/UpdateProductPackages",
  TRANSACTIONS_LOGS: "/Store/2/GetCashboxLedger",
  TRANSACTION_ENTRY: "/Store/2/CreateExpenseEntry",
  GET_EXPENSE_TYPES: "/Store/2/GetExpenseTypes",
  GET_EXPENSE_METHODS: "/Store/2/GetExpensePaymentMethods",
  GET_EXPENSE_METHODS_BALANCE: "/Store/2/GetExpensePaymentMethodBalance",
  CREATE_EXPENSE_TYPE: "/Store/2/CreateExpenseType",
  CREATE_EXPENSE: "/Store/2/CreateExpenseEntry",
  GET_EXPENSE_TRANSACTIONS: "/Store/2/GetExpenseTransactions",
  EDIT_DELETE_EXPENSE: "/Store/2/EditExpenseEntry",
  INVENTORY_SALE_SUMMARY: "/Store/2/SalesSummaryReport",
  INVENTORY_SALE_SUMMARY_EXCEL: "/Store/2/SalesSummaryReportExcel",
  CASHIER_INVENTORY_SALE_SUMMARY_EXCEL: "/Store/2/CashierSalesSummaryReportExcel",
  GET_PARENT_CATEGORY: "/Store/2/GetParentCategories",
  GET_SUB_CATEGORY: "/Store/2/GetSubCategories",
  CATEGORY_SALE_SUMMARY: "/Store/2/CategoryWiseSalesSummary",
  GET_CATEGORY_SALE_EXCEL: "/Store/2/CategoryWiseSalesSummary/Excel",
  GET_CASHIER_CATEGORY_SALE_EXCEL: "/Store/2/CashierCategoryWiseSalesSummaryExcel",
  GET_CASHIER_GROUP_SALE_EXCEL: "/Store/2/CashierGroupWiseSalesSummaryExcel",
  GET_CUSTOMER_CREDIT_ORDER: "/Store/2/GetPosCreditLedger",
  ADD_SECONDARY_BARCODE: "/Store/2/CreateUpdateProductBarcode",
  GET_SECONDARY_BARCODE: "/Store/2/GetProductBarcodes",
  GET_ALL_STORE_PROD_INFO: "/Store/2/GetAllStoreProductInformation",
  GET_POS_SESSION_LIST: "/Store/2/GetPosSessions",
  SEARCH_BY_SHORT_CODE: '/Store/2/SearchByProductShortCode',
  SEARCH_BY_SHORT_CODE_IN_STOCK_TRANSFER: '/Store/2/StockSearchProductByShortCode',
  GET_ALL_STORES_DATA_DASHBOARD: '/Store/2/GetAllStorePosDashboard',
  GET_STOCK_BY_CODE: "/Store/2/InventorySearchByProductShortCode",
  UPDATE_ALLSTORE_SALES_PRICE: "/Store/2/UpdateAllStoreSalesPrice",
  VERIFY_EGS_CODE: '/Store/2/VerifyEGSCode',
  UPDATE_PRODUCT_INFO: "/Store/2/UpdateProductInformation",
  GET_PRODUCT_HISTORY: "/Store/2/GetProductHistoryLogs",
  GET_PRODUCT_HISTORY_EXCEL: "/Store/2/ExportProductSalePurchaseInfo",

  // New E-Orders APIs Odoo
  GET_EORDER_DASHBOARD: "Store/2/GetEOrderDashboard",
  GET_LAHLOOB_EORDER_DASHBOARD: "Store/1/Lahloob/GetEOrderDashboard", // unchanged
  GET_EORDER_DASHBOARD_LAHLOOB: "Store/1/Lahloob/StoreDashboard", // unchanged
  ORDER_SEARCH_FILTER: "Store/1/Lahloob/SearchViewOrder", // unchanged
  GET_PAYMENT_INFO: "Store/1/Lahloob/GetBillDetails", // unchanged
  GET_ORDER_CANCEL_REASONS: "Store/2/CancelReason",
  LAHLOOB_CANCEL_REASON: "Store/1/Lahloob/RetailerCancelReason", // unchanged
  LAHLOOB_CANCEL_ORDER: "Store/1/Lahloob/RetailerCancelOrder", // unchanged
  UPDATE_CANCEL_REASON: "Store/2/CanceOrder",
  ACCEPT_ORDER: "Store/2/AceeptOrder",
  LAHLOOB_ACCEPT_ORDER: "/Lahloob/StoreAcceptOrder", // unchanged
  LAHLOOB_UPDATE_PICKER_ORDER: "Lahloob/StorePickerUpdateOrder", // unchanged
  LAHLOOB_ORDER_PREPARED: "Store/1/Lahloob/OrderReadyForDelivery", // unchanged
  UPDATE_E_ORDER: "Store/2/UpdateEOrder",
  PROCESS_ORDER: "Store/2/ProcessOrder",
  GET_DELIVERY_BOY: "Store/2/GetCashierDeliveryBoy",
  SET_DELIVERY_BOY: "Store/2/AssignDeliveryBoy",
  ORDER_DELIVER: "/DeliveryBoyDeliveredOrder",
  LAHLOOB_CONFIRM_RETURN_ORDER: "Store/1/Lahloob/ConfirmReturnOrder", // unchanged
  ORDER_HANDED_OVER: "/Lahloob/OrderHandedOver",
  CATEGORIES_BY_SHOP_TYPE: "/Store/2/GetCategoriesByShopType",
  CHECK_USER_ONBOARDING: "/Store/2/CheckUserOnboarding",
  REPLACE_PRODUCTS: "/Store/2/replace_order_item",
  DASHBOARD_SUMMARY: '/Store/2/DashboardSummary',
  POS_DASHBOARD: "/Store/2/GetPosDashboard",
  ONLINE_DASHBOARD: "/Store/2/GetEcomDashboard",
  DASHBOARD_POS_SUMMARY: '/Store/2/GetPosDashboard',
  LOGIN_API_URL: "Store/2/UserLogin",

  //Login,Signup and Logout Api ODOO
  // LOGIN_API_URL: "Store/1/Lahloob/UserLogin", // unchanged
  SIGNUP_OTP_API_URL: "Store/2/NewNumberSentOtp",
  VERIFY_OTP_API_URL: "Store/2/NewNumberVerifyOtp",
  LOGOUT_API_URL: "retialer-logout",

  //Register Api ODOO
  USER_SIGNUP_API_URL: "Store/2/UserSignup",
  GET_PLANS: "Store/2/GetPlans",

  SHOP_LOCATION_API_URL: "/V2/19/delivery_area_fencing",
  GET_STORE_TYPE: "/Store/2/ShopType",
  UPDATE_RETAILER_DETAILS: "/Store/2/UpdateRetailerDetails",
  NEW_GET_POLYGON: "/V2/23/fencing_cordinates",

  // Image upload urls
  UPLOAD_IMAGE_URLS: "/Store/2/RetailerShopImagesUpload",
  PROD_UPLOAD_IMAGE_URLS: "Store/2/ProductImageUpload",
  RETAILER_SHOP_IMAGE_UPLOAD: "/Store/2/RetailerShopImagesUpload",
  UPLOAD_RETAILER_DOCS: "/Store/2/UploadRetailerDocuments",

  // MY PROFILE API ODOO
  GET_RETAILER_DETAILS: "Store/2/GetRetailerDetails",
  GET_RETAILER_DOCS: "Store/2/GetRetailerDocuments",
  UPLOAD_RETAILER_DOCUMENTS: "Store/2/UploadRetailerDocuments",
  GET_RETAILER_CONTRACT: "/Store/2/GetRetailerContract",
  GET_BANK_DETAILS: "Store/2/get_bank_accounts",
  ADD_BANK_ACCOUNT: "Store/2/add_bank_account",
  GET_BANK_LIST: "/Store/2/get_bank_list",
  UPDATE_BANK_ACCOUNT: "/Store/2/edit_bank_account",


  // USER MANAGEMENT API ODOO
  GET_RETAILER_USER: "Store/2/GetReatilerUser",
  GET_RETAILER_EMAIL_USER: "Store/2/GetEmailUserList",
  GET_CASHIER_RETAILER_USER: "Store/2/GetCashierUserList",
  DEACTIVATE_RETAILER_USER: "Store/2/DeactivateReatilerUser",
  CREATE_REAILER_USER: "Store/2/CreateReatilerUser",
  EDIT_RETAILER_USER: "Store/2/UpdateReatilerUser",

  // SHIPPING COST API ODOO
  GET_SHIPPING_COSTS: "Store/2/GetShippingCost",
  GET_SERVICE_LEVEL: "Store/2/GetServiceLevel",
  GET_SERVICE_AREA: "Store/2/GetServiceArea",
  GET_DELIVERY_ZONE: "Store/2/GetDeliveryZone",
  CREATE_MULTIPLE_SHIPPING_COST: "Store/2/CreateMultipleShippingCost",
  UPDATE_SHIPPING_COST: "Store/2/CreateShippingCost",
  DELETE_SHIPPING_COST: "Store/2/DeleteShippingCost",

  // DELIVERY BOYS API ODOO
  CREATE_DELIVERY_BOY: "Store/2/CreateCashierDeliveryBoy",
  DEACTIVATE_DELIVERY_BOY: "Store/2/DeactivateDeliveryBoy",
  UPDATE_DELIVERY_BOY: "Store/2/UpdateDeliveryBoy",
  GET_DELIVERY_BOY_ORDERS: "Store/GetDeliveryBoyOrders",

  // SESSION HISTORY API ODOO
  GET_POS_SESSIONS: "Store/2/GetPosSessionList",
  GET_ALL_SESSIONS: "/Store/2/GetCashierSessions",
  GET_SESSION_DETAILS: '/Store/2/GetSessionDetails',
  GET_SESSION_SUMMARY_v4: "V4/PosOpenSessionDataAdmin",
  GET_SESSION_SUMMARY: "V5/PosOpenSessionDataAdmin",
  GET_POS_SESSION_HISTORY: "Store/2/GetPosSessionHistoryNew",
  CASH_IN_OUT: "Pos/CashInOut",
  POS_CLOSE_SESSION: "PosCloseSession",
  CREDIT_HISTORY: 'Store/2/GetPosCredit',
  GET_CREDIT_PAYMENT_HISTORY: "Store/2/POSCreditPaymentHistory",
  CASH_IN_OUT_REPORT: 'Store/2/GetPosCashInOut',
  GET_BULK_UPLOAD_HOSTORY: 'Store/2/GetRequestUploadBulkInventory',
  GET_POS_ORDERS: '/Store/2/GetPosOrders',
  GET_POS_ORDERS_EXCEL: '/Store/2/GetPosOrdersExcel',
  GET_POS_ORDER_LINES: '/Store/2/PosOrderLines',
  GET_POS_SALE_SUMMARY: "/Store/2/PosSaleSummary",
  GET_POS_SALE_SUMMARY_EXCEL: "/Store/2/DownloadPosSaleSummaryExcel",
  CASH_IN_OUT_EXCEL: '/Store/2/DownloadPosCashInOutExcel',
  CREDIT_HISTORY_EXCEL: '/Store/2/DownloadPosCreditExcel',
  CASHBOX_LEDGER_EXCEL: '/Store/2/GetCashboxLedgerExcel',
  VENDOR_PRODUCT_EXCEL: '/Store/2/DownloadVendorProductsExcel',
  GET_ITEM_WISE_SALE: "/Store/2/GetPosItemWiseSales",
  GET_ITEM_WISE_SALE_EXCEL: "/Store/2/GetPosItemWiseSalesExcel",
  GET_POS_ORDER_EXCEL: "/Store/2/GetPosOrdersExcel",
  GET_EXPIRY_PRODUCT: 'Store/2/GetExpiryProducts',
  GET_EXPIRY_PRODUCT_EXCEL: 'Store/2/DownloadExpiryProducts',

  TRANSACTION_SUMMARY_EXCEL: "/Store/2/TransactionSummaryExcel",
  GET_STORE_USER_ACCESS_RIGHTS: "/Store/2/GetStoreUserAccessRights",
  VERIFY_INVENTORY_PASSWORD: "/Store/2/VerifyInventoryPassword",
  POS_ORDER_FROM_SUMMARY: "/Store/2/PosOrderFromSummary",

  // PURCHASE API ODOO
  GET_VENDORS: "Store/2/GetVendors",
  GET_VENDORS_LIST: "Store/2/GetVendorList",
  CREATE_VENDOR: "Store/2/CreateVendor",
  UPDATE_VENDOR: "Store/2/UpdateVendor",
  SEARCH_PRODUCTS: "Store/2/SearchProduct",
  GET_PAYMENT_LIST: "Store/2/AllVendorBillsSin",
  GET_BILL_PAYMENT_HISTORY: "Store/2/BillPaymentDetails",
  GET_PAYMENT_TERMS: "/Store/2/GetJournals",
  GET_VENDORS_UNPAID_ORDERS: "/Store/2/GetVendorUnpaidOrders",
  REGISTER_PAYMENT: "Store/2/RegisterPayment",
  GET_DEPOSIT_PAYMENT_AMOUNT: "/Store/2/GetDepositPaymentMethodBalance",
  GET_PURCHASE_LIST: "Store/Web/Purchase/GetPurchaseOrder",
  UPLOAD_PO_IMAGE: "Store/2/UploadPOImage",
  GET_PAY_TERMS: "/Store/2/GetPaymentTerms",
  CREATE_PURCHASE_ORDER: "/Store/Web/Purchase/CreatePurchaseOrder",
  ADD_BARCODE: "Store/2/AddBarcode",
  GET_VENDOR_INFO: "/Store/2/GetVendorsSalePurchaseInformation",
  GET_VENDOR_INVENTORY_INFO: "/Store/2/VendorLowHighInventory",
  GET_VENDOR_PRODUCTS: "/Store/2/GetVendorProducts",
  PURCHASE_DASHBOARD: "Store/2/DashboardData",
  CANCEL_ORDER: '/Store/2/CancelledPurchaseOrder',

  // Cashback APIs Odoo
  CASHBACK_DETAILS: "V2/19/getRetailerCashbackDetails",
  CASHBACK_PAYMENT_HISTORY: "/V2/19/getCashbackPaymentHistory",

  // Forgot Password and update Password APIs ODOO
  SEND_OTP: "Store/2/SentOTP",
  VERIFY_OTP: "Store/2/VerifyOTP",
  UPDATE_PASSWORD: "Store/2/ForgetPassword",

  // Dashboard APIs ODOO
  GET_HOME_DASH_DATA: "/Store/2/RetailerDashboard",
  GET_LAHLOOB_HOME_DASH_DATA: "/Store/1/Lahloob/StoreDashboard", // unchanged
  GET_STORE_PAYMENT_DATA: "/Lahloob/FleetManagerStorePaymentData",

  //Subscritoption
  GET_SUBSCRIPTION_PLANS: '/Store/2/getsubscriptionplans',
  GET_RETAILER_SUBSCRIPTION: 'Store/2/GetReatilerSubscription',
  RETAILER_FAWRT_PAYMENT: '/Store/2/retailer_fawry_payment',
  RETAILER_PAYMOB_PAYMENT: '/Store/2/retailer_paymob_payment',
  GET_SUBSCRIPTION_UPGRADE_PLANS: '/Store/2/GetUpgradePlanDetails',
  UPGRADE_PLAN: '/Store/2/UpgradeSubscription',
  UPGRADE_PLAN_PAYMOB: "/Store/2/PaymobUpgradeSubscription",
  GET_SUBSCRIPTION_HISTORY: '/Store/2/GetSubscriptionPaymentHistory',
  UPGRADE_USERS_OR_DEVICE: "/Store/2/UpgradeUserOrDevice",
  UPGRADE_USERS_OR_DEVICE_PAYMOB: "/Store/2/PaymobUpgradeUserOrDevice",
  CONFIRM_PAYMOB_PAYMENT: "/paymobpayconformation/",
  CHECK_SUBSCRIPTION_COUPON: '/Store/2/CheckSubscriptionCoupon',
  // ACCOUNTING APIs ODOO 
  GET_ACCOUNTING_PROFIT_LOSS: "/Store/2/GetAccountingProfitLoss",
  GET_ACCOUNTING_OVERVIEW: "/Store/2/GetAccountingOverview",

  // PRODUCT GROUPS 
  GET_PRODUCT_GROUPS: "/Store/2/GetProductGroup",
  UPDATE_PRODUCT_GROUP: "/Store/2/CreateProductGroup",
  DELETE_PRODUCT_GROUP: "/Store/2/EditProductGroup",
  GET_GROUP_PRODUCT: "/Store/2/GetProductGroupProducts",
  CREATE_PRODUCT_GROUP: "/Store/2/CreateProductGroup",
  EDIT_GROUP: "/Store/2/EditProductGroup",

  GET_INVENTORY_WISE_SALES: "/Store/2/CashierSalesSummaryReport",
  GET_CATEGORY_WISE_SALES: "/Store/2/CashierCategoryWiseSalesSummary",
  GET_GROUP_WISE_SALES: "/Store/2/CashierGroupWiseSalesSummary",
  GET_DISCOUNT_WISE_SALES: "/Store/2/CashierSalesDiscountReport",
  GET_DISCOUNT_SALE_EXCEL: "/Store/2/CashierSalesDiscountReportExcel",

  //  Tax APIS
  GET_ALL_PRODUCTS_WITH_VAT: '/Store/2/GetProductTaxes',
  CREATE_VAT_TYPE: '/Store/2/CreateTaxes',
  GET_VAT_TYPES: '/Store/2/GetTaxes',
  UPDATE_VAT: '/Store/2/UpdateTaxes',
  GET_VAT_CATEGORIES: '/Store/2/GetTaxParentCategories',
  GET_VAT_SUB_CATEGORIES: '/Store/2/GetTaxSubCategories',
  GET_PRODUCT_GROUP_TAX: '/Store/2/GetProductGroupTaxes',
  CREATE_PRODUCT_GROUP_TAX: '/Store/2/CreateProductGroupTaxes',
  ADD_VAT_TO_PRODUCTS: '/Store/2/CreateProductTaxes',
  ADD_VAT_TO_CATEGORY: '/Store/2/CreateCategoryTaxes',
  UPDATE_PRODUCT_TAX: '/Store/2/UpdateProductTaxes',

  // Hampers APIS
  CREATE_HAMPER: "/Store/2/CreateHamper",
  GET_ALL_HAMPERS: "/Store/2/GetHampers",
  GET_HAMPER_ITEMS: "/Store/2/GetHamperItems",
  UPDATE_HAMPER_DETAILS: "/Store/2/UpdateHamper",
  CHECK_HAMPER_DUBLICATION: "/Store/2/CheckHamperDuplication",
  // ------------------------------------------------------------

  //Orders
  GET_ALL_ORDERS_API_URL: "GetAllOrders", //
  GET_ALL_inventory_API_URL: "GetAllInventory",

  //profile
  GET_STORE_BASIC_DETAIL: "getstorebasicdetails",
  GET_STORE_SHOP_DETAIL: "getshopdetails",
  GET_STORE_BUSINESSPROOF: "getstorebussinessproof",
  GET_BDO_DETAILS: "getbdodetails",
  SET_STORE_BASIC_DETAIL: "updatebasicdetails",
  SET_STORE_SHOP_DETAIL: "updateshopdetails",
  SET_STORE_BUSINESSPROOF: "updatebussinessproof",

  //Delivery Partner
  DELIVERY_PARTNER_CREATE: "retialer-createdeliverypartner",
  DELIVERY_PARTNER_DETAILS: "retialer-getdeliverypartner",
  UPDATE_DELIVERY_PARTNER: "retialer-updatedeliverypartner",
  GET_DELIVERY_PARTNER_ORDERS: "delivery_partner_orders",
  SEARCH_DELIVERY_PARTNER: "searchdeliverypartner",

  //Orders Api
  GET_STORE_ORDER_COUNT: "storeordercount",
  GET_KPI_DETAIL: "getordersdetailsamount",
  GET_STAGE_IDS: "getorderstages",
  GET_ALL_ORDERS: "getordersdetails",
  UPDATE_ORDERLINE: "updateorderline",
  SEARCH_ORDER: "searchorder",
  UPDATE_ORDER_STAGE: "updateorderstages",
  ORDER_NOTIFICATION: "/ordernotification",
  NOTIFICATIONS: "/Store/2/GetNotifications",
  UNREAD_NOTIFICATION_COUNT: "/Store/2/GetUnreadNotificationCount",
  MARK_READ_NOTIFICATION: "/Store/2/MarkNotificationsAsRead",

  //Inventory Api
  GET_INVENTORY_PRODUCT_LOGS: "getproductlog",
  CATEGORY_FILTER: "categoryfilter",
  SEARCH_INVENTORY: "searchinventory",
  STOCKOUT_SEARCH_INVENTORY: "searchoutstockinventory",
  HIGHON_SEARCH_INVENTORY: "searchhighinventory",
  LOWON_SEARCH_INVENTORY: "searclowhinventory",
  INVENTORY_REPORT: "inventory_report",
  FETCH_GS1_DATA: "fetch_gs1_data",
  GET_INVENTORY_DEBOUNCE_FILE: "/Store/2/DownloadBulkUploadedFile",

  //User Management
  GET_ALL_STORE_USERS: "getallstoreusers",
  GET_USER_TYPES: "getstoreusertype",
  GET_RETAILER_USER_ACCESS: "Store/2/GetUserAccessmentUserList",

  //subscription
  MY_SUBSCRIPTION: "getSubscriptionstion",
  SUBSCRIPTION_PLANS: "getSubscriptionstionPlans",

  //payment settlement reports
  SETTLEMENT_REPORT: "Store/2/WeeklySettlementReport",
  TRANSACTION_SUMARY: "Store/2/TransactionSummary",
  TRANSACTION_SUMARY_NEW: "Store/2/TransactionSummaryNew",
  TRANSACTION_SUMMARY_EXCEL: "/Store/2/TransactionSummaryExcel",

  // Cashier Setup api's
  GET_SELECTED_METHODS: "V3/PaymentMethod",
  GET_ALL_METHODS: "Store/2/PaymentMethods",
  UPDATE_METHODS: "Store/2/SetPaymentMethods",
  ORDER_FROM: "Store/2/POSOrderFrom",
  UPDATE_ORDER_FROM: "Store/2/UpdatePOSOrderFrom",
  UPDATE_USER_RIGHTS: "/Store/2/UpdateReatilerUserRights",
  GET_ORDER_FROM_OPTIONS: "/Store/2/PosOrderFromList",

  // forLandingPage
  TALK_TO_SALES: "/Store/2/TalkToSales",

  //Sidebar
  SIDEBAR: "/Store/2/GetStoresMenus",

  // User Access Management 
  GET_STORE_MENUS: "/Store/2/GetStoresMenus",
  GET_STORE_USER_MENUS: "/Store/2/GetStoreUserMenus",
  UPDATE_STORE_USER_MENUS: "/Store/2/UpdateStoreUserMenus",


  // Product Expire
  CHECK_PRICE: '/Store/2/ProductPriceChecker',
  PRODUCT_EXPIRY_DETAILS: "/Store/2/ProductExpiryDetails",
  CREATE_PRODUCT_EXPIRY: "/Store/2/CreateProductExpiry",
  GET_PRODUCT_EXPIRY: 'Store/2/GetProductExpiry',
  GET_PRODUCT_EXPIRY_EXCEL: 'Store/2/ExportProductExpiry',
  UPDATE_PRODUCT_EXPIRY: "Store/2/UpdateProductExpiry",
  GET_EXPIRY_DASHBOARD: "Store/2/GetProductExpiryDashboard",
  UPLOAD_BULK_EXPIRY: "/Store/2/BulkUploadProductExpiry",


  // Salesman APIs
  GET_SALESMAN: "/Store/2/GetSalesman",
  CREATE_SALESMAN: "/Store/2/CreateSalesman",
  UPDATE_SALESMAN: "/Store/2/UpdateSalesman",
  GET_SALESMAN_REPORT: "/Store/2/CashierSalesSalesmanReport",
  GET_SALESMAN_WISE_SALE_EXCEL: "/Store/2/CashierSalesSalesmanReportExcel",


  // CUSTOMERS
  GET_CUSTOMERS: '/Store/2/GetCustomers',
  CREATE_NEW_CUSTOMER: "/Store/2/CreateCustomers",
  UPDATE_CUSTOMER: "/Store/2/UpdateCustomer",
  UPLOAD_BULK_CUSTOMER: "/Store/2/RequestUploadBulkCustomer",
  GET_CUSTOMER_BULK_UPLOAD_HISTORY: "/Store/2/GetBulkCustomerUploadStatus",
  GET_BOUNCE_FILE: "/Store/2/GetCustomerBounceFile",

  // DOWNLOAD EXCEL NEW APIS
  GET_SALES_SUMMARY_REPORT: "/Store/2/CashierSalesSummaryReportExcel",
  GET_GROUP_WISE_SALES_SUMMARY_REPORT: "/Store/2/CashierGroupWiseSalesSummaryExcel",
  GET_DISCOUNT_WISE_SALES_SUMMARY_REPORT: "/Store/2/CashierSalesDiscountReportExcel",
  GET_SALES_SALESMAN_REPORT_EXCEL: "Store/2/CashierSalesSalesmanReportExcel",
  GET_CATEGORY_WISE_SALES_REPORT: "/Store/2/CashierCategoryWiseSalesSummaryExcel",
  GET_INVENTORY_WISE_SALES_REPORT: "/Store/2/CashierSalesSummaryReportExcel",
  DOWNLOAD_VENDOR_PRODUCTS_EXCEL: "/Store/2/DownloadVendorProductsExcel",
  GET_EXCEL_POS_ORDERS: "/Store/2/GetPosOrdersExcel",
  POS_CREDIT_EXCEL: "/Store/2/DownloadPosCreditExcel",
  POS_CASH_IN_OUT_EXCEL: "/Store/2/DownloadPosCashInOutExcel",
  GET_STOCK_TRANSFER_INTERNAL_REPORT: "/Store/2/GetStockTransferInternalReportExcel",


  //PROMOTIONS
  CREATE_PROMOTION: '/Store/2/CreatePromotions',
  GET_PROMOTIONS: '/Store/2/GetPromotions',
  UPDATE_PROMOTIONS: '/Store/2/UpdatePromotions',
  DELETE_PROMOTIONS: '/Store/2/DeletePromotions',
  GET_PROMOTION_DETAILS: '/Store/2/GetPromotionsDetails',
  CREATE_CASHIER_OFFER: "/Store/2/CreateCashierOffer",
  GET_CASHIER_OFFERS: "/Store/2/GetCashierOffers",
  UPDATE_CASHIER_OFFER: "/Store/2/UpdateCashierOffer",
  GET_CASHIER_OFFER_TYPES: "/Store/2/GetCashierOffersTemplates",
  GET_CASHIER_SALES_PROMOTION_REPORT: "/Store/2/CashierSalesPromotionReport",
  GET_CASHIER_SALES_PROMOTION_EXCEL: "/Store/2/CashierSalesPromotionReportExcel",


  // INVENTORY VALIDATION
  CREATE_INVENTORY_STOCK_VALIDATION: '/Store/2/CreateInventoryStockVerification',
  GET_INVENTORY_STOCK_VALIDATION: '/Store/2/GetInventoryStockVerification',
  GET_INVENTORY_STOCK_VALIDATION_ITEMS: '/Store/2/GetInventoryStockVerificationItems',
  GET_INVENTORY_STOCK_VALIDATION_EXCEL: '/Store/2/GetInventoryStockVerificationReportExcel',


  //SUBGROUPS
  GET_PARENT_PRODUCT_GROUP:"/Store/2/GetParentProductGroup",
  GET_SUBGROUPS:"/Store/2/GetSubGroup",

  //DELIVERY BOYS
  CREATE_CASHIER_DELIVERY_BOY:"/Store/2/CreateCashierDeliveryBoy",
  GET_CASHIER_DELIVERY_BOY:"/Store/2/GetCashierDeliveryBoy",
  UPDATE_CASHIER_DELIVERY_BOY:"/Store/2/UpdateCashierDeliveryBoy",
  GET_DELIVERY_BOY_REPORT:"/Store/2/CashierDeliveryBoyReport",
  GET_DELIVERY_BOY_REPORT_EXCEL:"/Store/2/CashierDeliveryBoyReportExcel"

};




// export const URLS = {
//   GET_POLYGONS: "/V2/19/delivery_area_fencing",
//   GET_AREAS: "/V2/19/GetDeliveryArea",
//   LOG_BUTTON_CLICK: "api/log_button_click",

//   LOGIN_SEND_OTP: '/Store/1/LoginPhoneSentOtp',
//   LOGIN_VERIFY_OTP: '/Store/1/LoginPhoneVerifyOtp',
//   GET_LOGIN_DATA: "/Store/1/LoginWithPhone",
//   GET_LOGIN_RETAILERS: "/Store/1/GetAssociatedRetailersWithUsers",

//   // Master Store APIs Odoo
//   GET_SUB_STORE: "/Store/1/GetSubStores",
//   SEARCH_SUBSTORE_INVENTORY: "/Store/1/StockSearchProduct",
//   CREATE_STOCK_TRANSFER: "/Store/1/CreateStockTransferInternal",
//   GET_STOCK_REPORT: "/Store/1/GetStockTransferInternalReport",
//   GET_STOCK_SUMMARY_EXCEL: "/Store/1/GetStockTransferInternalReportExcel",
//   CREATE_SUB_STORE: "/Store/1/CreateStoreBranch",
//   DELETE_STORE_BRANCH: "/Store/1/DeleteStoreBranch",
//   DEACTIVATE_STORE_BRANCH: "/Store/1/DeactivateStoreBranch",
//   ACTIVATE_STORE_BRANCH: "/Store/1/ActivateStoreBranch",
//   GET_SUB_STORE_DATA: "/Store/1/GetStoreBranchDetails",
//   UPDATE_SUBSTORE_DATA: "/Store/1/UpdateStoreBranch",
//   VERIFY_BRANCH_DATA: "/Store/1/VerifySubStoreDetails",


//   // Money Transfer APIs Odoo 
//   CREATE_MONEY_TRANSFER: "/Store/1/CreateMoneyTransfer",
//   GET_MONEY_TRANSFER: "/Store/1/GetMoneyTransfer",
//   EDIT_MONEY_TRANSFER: "/Store/1/EditMoneyTransfer",
//   GET_MONEY_TRANSFER_EXCEL: "/Store/1/GetMoneyTransferExcel",
//   GET_BALANCE: "/Store/1/GetTransferBalance",





//   // New Inventory APIs Odoo
//   GET_INVENTORY_DASHBOARD: "/Store/1/GetInventoryDashboard",
//   GET_ALL_PRODUCTS: "/Store/1/GetInstantStockDetails",
//   GET_RETAILER_PRODUCT_CATEGORY: "/Store/1/GetCategories",
//   GET_INCOMPLETE_PRODUCTS: "/Store/1/GetSalesCostPriceProducts",
//   UPDATE_STORE_PRODUCT_DETAIL: "/Store/1/InstantStockUpdate",
//   UPDATE_STORE_INCOMPLETE_PRODUCT_DETAIL: "/Store/1/AddSalesCostPrice",
//   SEARCH_INVENTORY_ONBOARD: "Store/1/ScanBarcode",
//   ADD_PRODUCT: "Store/1/AddProduct",
//   GET_UOM: "Store/1/GetUoms",
//   PRODUCT_REQUEST: "/Store/1/ProductRequest",
//   UPDATE_GS_PRODUCT_REQUEST: "/update_gs_product_request",
//   UPLOAD_BULK_INVENTORY: "/UploadBulkInventory",
//   UPLOAD_BULK_INVENTORY_NEW: "Store/1/RequestUploadBulkInventory",
//   GET_OUT_LOW_HIGH: "/Store/1/GetInstantStockDetailsOutofStock",
//   GET_PROD_INFO: "/Store/1/GetProductInformation",
//   GET_PROD_PURCHASE_DATA: "/Store/1/GetProductPurchaseInformation",
//   GET_PROD_SALE_PURCHASE_DATA: "/Store/1/GetProductSalePurchaseInfo",
//   GET_PROD_SALE_DATA: "/Store/1/GetProductSalesInformation",
//   EXPORT_INVENTORY: "/Store/1/DowloadAllInventory",
//   GET_PRODUCT_PACKAGE: "/Store/1/GetProductPackages",
//   UPDATE_PRODUCT_PACKAGE: "/Store/1/UpdateProductPackages",
//   TRANSACTIONS_LOGS: "/Store/1/GetCashboxLedger",
//   TRANSACTION_ENTRY: "/Store/1/CreateExpenseEntry",
//   GET_EXPENSE_TYPES: "/Store/1/GetExpenseTypes",
//   CREATE_EXPENSE_TYPE: "/Store/1/CreateExpenseType",
//   CREATE_EXPENSE: "/Store/1/CreateExpenseEntry",
//   GET_EXPENSE_TRANSACTIONS: "/Store/1/GetExpenseTransactions",
//   EDIT_DELETE_EXPENSE: "/Store/1/EditExpenseEntry",
//   INVENTORY_SALE_SUMMARY: "/Store/1/SalesSummaryReport",
//   INVENTORY_SALE_SUMMARY_EXCEL: "/Store/1/SalesSummaryReportExcel",
//   GET_PARENT_CATEGORY: "/Store/1/GetParentCategories",
//   GET_SUB_CATEGORY: "/Store/1/GetSubCategories",
//   CATEGORY_SALE_SUMMARY: "/Store/1/CategoryWiseSalesSummary",
//   GET_CATEGORY_SALE_EXCEL: "/Store/1/CategoryWiseSalesSummary/Excel",
//   GET_CUSTOMER_CREDIT_ORDER: "/Store/1/GetPosCreditLedger",


//   // New E-Orders APIs Odoo
//   GET_EORDER_DASHBOARD: "Store/1/GetEOrderDashboard",
//   GET_LAHLOOB_EORDER_DASHBOARD: "Store/1/Lahloob/GetEOrderDashboard",
//   GET_EORDER_DASHBOARD_LAHLOOB: "Store/1/Lahloob/StoreDashboard",
//   ORDER_SEARCH_FILTER: "Store/1/Lahloob/SearchViewOrder",
//   GET_PAYMENT_INFO: "Store/1/Lahloob/GetBillDetails",
//   GET_ORDER_CANCEL_REASONS: "Store/1/CancelReason",
//   LAHLOOB_CANCEL_REASON: "Store/1/Lahloob/RetailerCancelReason",
//   LAHLOOB_CANCEL_ORDER: "Store/1/Lahloob/RetailerCancelOrder",
//   UPDATE_CANCEL_REASON: "Store/1/CanceOrder",
//   ACCEPT_ORDER: "Store/1/AceeptOrder",
//   LAHLOOB_ACCEPT_ORDER: "/Lahloob/StoreAcceptOrder",
//   LAHLOOB_UPDATE_PICKER_ORDER: "Lahloob/StorePickerUpdateOrder",
//   LAHLOOB_ORDER_PREPARED: "Store/1/Lahloob/OrderReadyForDelivery",
//   UPDATE_E_ORDER: "Store/1/UpdateEOrder",
//   PROCESS_ORDER: "Store/1/ProcessOrder",
//   GET_DELIVERY_BOY: "Store/1/GetDeliveryBoy",
//   SET_DELIVERY_BOY: "Store/1/AssignDeliveryBoy",
//   ORDER_DELIVER: "/DeliveryBoyDeliveredOrder",
//   LAHLOOB_CONFIRM_RETURN_ORDER: "Store/1/Lahloob/ConfirmReturnOrder",
//   ORDER_HANDED_OVER: "/Lahloob/OrderHandedOver",
//   CATEGORIES_BY_SHOP_TYPE: "/Store/1/GetCategoriesByShopType",
//   CHECK_USER_ONBOARDING: "/Store/1/CheckUserOnboarding",
//   REPLACE_PRODUCTS: "/Store/1/replace_order_item",
//   DASHBOARD_SUMMARY: '/Store/1/DashboardSummary',
//   POS_DASHBOARD: "/Store/1/GetPosDashboard",
//   ONLINE_DASHBOARD: "/Store/1/GetEcomDashboard",
//   DASHBOARD_POS_SUMMARY: '/Store/1/GetPosDashboard',
//   //Login,Signup and Logout Api ODOO
//   LOGIN_API_URL: "Store/1/Lahloob/UserLogin",
//   SIGNUP_OTP_API_URL: "Store/1/NewNumberSentOtp",
//   VERIFY_OTP_API_URL: "Store/1/NewNumberVerifyOtp",
//   LOGOUT_API_URL: "retialer-logout",

//   //Register Api ODOO
//   USER_SIGNUP_API_URL: "Store/1/UserSignup",
//   GET_PLANS: "Store/1/GetPlans",

//   // SHOP_LOCATION_API_URL: "GetDeliveryArea" ODOO
//   SHOP_LOCATION_API_URL: "/V2/19/delivery_area_fencing",
//   GET_STORE_TYPE: "/Store/1/ShopType",
//   UPDATE_RETAILER_DETAILS: "/Store/1/UpdateRetailerDetails",
//   NEW_GET_POLYGON: "/V2/21/fencing_cordinates",

//   // Image upload urls
//   UPLOAD_IMAGE_URLS: "/Store/1/RetailerShopImagesUpload",
//   PROD_UPLOAD_IMAGE_URLS: "Store/1/ProductImageUpload",
//   RETAILER_SHOP_IMAGE_UPLOAD: "/Store/1/RetailerShopImagesUpload",

//   UPLOAD_RETAILER_DOCS: "/Store/1/UploadRetailerDocuments",

//   // MY PROFILE API ODOO
//   GET_RETAILER_DETAILS: "Store/1/GetRetailerDetails",
//   GET_RETAILER_DOCS: "Store/1/GetRetailerDocuments",
//   UPLOAD_RETAILER_DOCUMENTS: "Store/1/UploadRetailerDocuments",
//   GET_RETAILER_CONTRACT: "/Store/1/GetRetailerContract",
//   GET_BANK_DETAILS: "Store/1/get_bank_accounts",
//   ADD_BANK_ACCOUNT: "Store/1/add_bank_account",
//   GET_BANK_LIST: "/Store/1/get_bank_list",
//   UPDATE_BANK_ACCOUNT: "/Store/1/edit_bank_account",


//   // USER MANAGEMENT API ODOO
//   GET_RETAILER_USER: "Store/1/GetReatilerUser",
//   DEACTIVATE_RETAILER_USER: "Store/1/DeactivateReatilerUser",
//   CREATE_REAILER_USER: "Store/1/CreateReatilerUser",
//   EDIT_RETAILER_USER: "Store/1/UpdateReatilerUser",

//   // SHIPPING COST API ODOO
//   GET_SHIPPING_COSTS: "Store/1/GetShippingCost",
//   GET_SERVICE_LEVEL: "Store/1/GetServiceLevel",
//   GET_SERVICE_AREA: "Store/1/GetServiceArea",
//   GET_DELIVERY_ZONE: "Store/1/GetDeliveryZone",
//   CREATE_MULTIPLE_SHIPPING_COST: "Store/1/CreateMultipleShippingCost",
//   UPDATE_SHIPPING_COST: "Store/1/CreateShippingCost",
//   DELETE_SHIPPING_COST: "Store/1/DeleteShippingCost",

//   // DELIVERY BOYS API ODOO
//   CREATE_DELIVERY_BOY: "Store/1/CreateDeliveryBoy",
//   DEACTIVATE_DELIVERY_BOY: "Store/1/DeactivateDeliveryBoy",
//   UPDATE_DELIVERY_BOY: "Store/1/UpdateDeliveryBoy",
//   GET_DELIVERY_BOY_ORDERS: "Store/GetDeliveryBoyOrders",

//   // SESSION HISTORY API ODOO
//   GET_POS_SESSIONS: "Store/1/GetPosSessionList",
//   GET_SESSION_SUMMARY: "V4/PosOpenSessionDataAdmin",
//   // GET_POS_SESSION_HISTORY: "Store/1/GetPosSessionHistory",
//   GET_POS_SESSION_HISTORY: "Store/1/GetPosSessionHistoryNew",
//   CASH_IN_OUT: "Pos/CashInOut",
//   POS_CLOSE_SESSION: "PosCloseSession",
//   CREDIT_HISTORY: 'Store/1/GetPosCredit',
//   GET_CREDIT_PAYMENT_HISTORY: "Store/1/POSCreditPaymentHistory",
//   CASH_IN_OUT_REPORT: 'Store/1/GetPosCashInOut',
//   GET_BULK_UPLOAD_HOSTORY: 'Store/1/GetRequestUploadBulkInventory',
//   GET_POS_ORDERS: '/Store/1/GetPosOrders',
//   GET_POS_ORDERS_EXCEL: '/Store/1/GetPosOrdersExcel',
//   GET_POS_ORDER_LINES: '/Store/1/PosOrderLines',
//   GET_POS_SALE_SUMMARY: "/Store/1/PosSaleSummary",
//   GET_POS_SALE_SUMMARY_EXCEL: "/Store/1/DownloadPosSaleSummaryExcel",
//   CASH_IN_OUT_EXCEL: '/Store/1/DownloadPosCashInOutExcel',
//   CREDIT_HISTORY_EXCEL: '/Store/1/DownloadPosCreditExcel',
//   CREDIT_HISTORY_EXCEL: '/Store/1/DownloadPosCreditExcel',
//   CASHBOX_LEDGER_EXCEL: '/Store/1/GetCashboxLedgerExcel',
//   VENDOR_PRODUCT_EXCEL: '/Store/1/DownloadVendorProductsExcel',
//   GET_ITEM_WISE_SALE: "/Store/1/GetPosItemWiseSales",
//   GET_ITEM_WISE_SALE_EXCEL: "/Store/1/GetPosItemWiseSalesExcel",
//   GET_POS_ORDER_EXCEL: "/Store/1/GetPosOrdersExcel",
//   GET_EXPIRY_PRODUCT: 'Store/1/GetExpiryProducts',
//   GET_EXPIRY_PRODUCT_EXCEL: 'Store/1/DownloadExpiryProducts',





//   TRANSACTION_SUMMARY_EXCEL: "/Store/1/TransactionSummaryExcel",
//   // PURCHASE API ODOO
//   GET_VENDORS: "Store/1/GetVendors",
//   CREATE_VENDOR: "Store/1/CreateVendor",
//   SEARCH_PRODUCTS: "Store/1/SearchProduct",
//   GET_PAYMENT_LIST: "Store/1/AllVendorBillsSin",
//   GET_BILL_PAYMENT_HISTORY: "Store/1/BillPaymentDetails",
//   GET_PAYMENT_TERMS: "/Store/1/GetJournals",
//   GET_VENDORS_UNPAID_ORDERS: "/Store/1/GetVendorUnpaidOrders",

//   REGISTER_PAYMENT: "Store/1/RegisterPayment",
//   // GET_PURCHASE_LIST: "Store/1/GetPurchaseOrder",
//   GET_PURCHASE_LIST: "Store/Web/Purchase/GetPurchaseOrder",
//   UPLOAD_PO_IMAGE: "Store/1/UploadPOImage",
//   GET_PAY_TERMS: "/Store/1/GetPaymentTerms",
//   CREATE_PURCHASE_ORDER: "/Store/Web/Purchase/CreatePurchaseOrder",
//   ADD_BARCODE: "Store/1/AddBarcode",
//   GET_VENDOR_INFO: "/Store/1/GetVendorsSalePurchaseInformation",
//   GET_VENDOR_INVENTORY_INFO: "/Store/1/VendorLowHighInventory",
//   GET_VENDOR_PRODUCTS: "/Store/1/GetVendorProducts",
//   PURCHASE_DASHBOARD: "Store/1/DashboardData",

//   // Cashback APIs Odoo
//   CASHBACK_DETAILS: "V2/19/getRetailerCashbackDetails",
//   CASHBACK_PAYMENT_HISTORY: "/V2/19/getCashbackPaymentHistory",

//   // Forgot Password and update Password APIs ODOO
//   SEND_OTP: "Store/1/SentOTP",
//   VERIFY_OTP: "Store/1/VerifyOTP",
//   UPDATE_PASSWORD: "Store/1/ForgetPassword",

//   // Dashboard APIs ODOO
//   GET_HOME_DASH_DATA: "/Store/1/RetailerDashboard",
//   GET_LAHLOOB_HOME_DASH_DATA: "/Store/1/Lahloob/StoreDashboard",
//   GET_STORE_PAYMENT_DATA: "/Lahloob/FleetManagerStorePaymentData",

//   //Subscritoption
//   GET_SUBSCRIPTION_PLANS: '/Store/2/getsubscriptionplans',
//   GET_RETAILER_SUBSCRIPTION: 'Store/2/GetReatilerSubscription',
//   RETAILER_FAWRT_PAYMENT: '/Store/2/retailer_fawry_payment',
//   GET_SUBSCRIPTION_UPGRADE_PLANS: '/Store/2/GetUpgradePlanDetails',
//   UPGRADE_PLAN: '/Store/2/UpgradeSubscription',
//   GET_SUBSCRIPTION_HISTORY: '/Store/2/GetSubscriptionPaymentHistory',
//   UPGRADE_USERS_OR_DEVICE: "/Store/2/UpgradeUserOrDevice",



//   // ACCOUNTING APIs ODOO 
//   GET_ACCOUNTING_PROFIT_LOSS: "Store/1/GetAccountingProfitLoss",
//   GET_ACCOUNTING_OVERVIEW: "Store/1/GetAccountingOverview",


//   // ------------------------------------------------------------

//   //Orders
//   GET_ALL_ORDERS_API_URL: "GetAllOrders", //

//   //Inventory
//   GET_ALL_inventory_API_URL: "GetAllInventory",

//   //profile
//   //getapis
//   GET_STORE_BASIC_DETAIL: "getstorebasicdetails",
//   GET_STORE_SHOP_DETAIL: "getshopdetails",
//   GET_STORE_BUSINESSPROOF: "getstorebussinessproof",

//   GET_BDO_DETAILS: "getbdodetails",

//   //POSTapis
//   SET_STORE_BASIC_DETAIL: "updatebasicdetails",
//   SET_STORE_SHOP_DETAIL: "updateshopdetails",
//   SET_STORE_BUSINESSPROOF: "updatebussinessproof",

//   //Delivery Partner
//   DELIVERY_PARTNER_CREATE: "retialer-createdeliverypartner", //
//   DELIVERY_PARTNER_DETAILS: "retialer-getdeliverypartner", //Get API
//   UPDATE_DELIVERY_PARTNER: "retialer-updatedeliverypartner",
//   GET_DELIVERY_PARTNER_ORDERS: "delivery_partner_orders",
//   SEARCH_DELIVERY_PARTNER: "searchdeliverypartner",

//   //Orders Api
//   GET_STORE_ORDER_COUNT: "storeordercount",
//   GET_KPI_DETAIL: "getordersdetailsamount",
//   GET_STAGE_IDS: "getorderstages",
//   GET_ALL_ORDERS: "getordersdetails",
//   UPDATE_ORDERLINE: "updateorderline",
//   SEARCH_ORDER: "searchorder",
//   // GET_ORDER_CANCEL_REASONS: "getordercancelreason",
//   // UPDATE_CANCEL_REASON: "updateordercancelreason",
//   UPDATE_ORDER_STAGE: "updateorderstages",
//   // ORDER_SEARCH_FILTER: "searchfilter",
//   ORDER_NOTIFICATION: "/ordernotification",

//   //Inventory Api
//   // GET_UOM: "GetUom",
//   // GET_RETAILER_PRODUCT_CATEGORY: "getretailerproductcategory",
//   // GET_ALL_PRODUCTS: "getretailerallproduct",
//   GET_INVENTORY_PRODUCT_LOGS: "getproductlog",
//   // UPDATE_STORE_PRODUCT_DETAIL: "updatestoreproductdetails",
//   // GET_INCOMPLETE_PRODUCTS: "getallincompleteproduct",
//   CATEGORY_FILTER: "categoryfilter",
//   SEARCH_INVENTORY: "searchinventory",
//   STOCKOUT_SEARCH_INVENTORY: "searchoutstockinventory",
//   HIGHON_SEARCH_INVENTORY: "searchhighinventory",
//   LOWON_SEARCH_INVENTORY: "searclowhinventory",
//   // PRODUCT_REQUEST: "/productrequest",

//   // SEARCH_INVENTORY_ONBOARD: "searchinventoryonboard",
//   // ADD_PRODUCT: "updateinventoryonboard",
//   INVENTORY_REPORT: "inventory_report",
//   FETCH_GS1_DATA: "fetch_gs1_data",

//   //User Management
//   // CREATE_STORE_USER: "createstoreuser",
//   GET_ALL_STORE_USERS: "getallstoreusers",
//   GET_USER_TYPES: "getstoreusertype",
//   // UPDATE_STORE_USER: "UpdateRetailerUser",
//   // INACTIVE_STORE_USER: "/inactiveretaileruser",

//   //subscription
//   MY_SUBSCRIPTION: "getSubscriptionstion",
//   SUBSCRIPTION_PLANS: "getSubscriptionstionPlans",

//   //payment settlement reports
//   SETTLEMENT_REPORT: "Store/1/WeeklySettlementReport",
//   TRANSACTION_SUMARY: "Store/1/TransactionSummary",
//   TRANSACTION_SUMARY_NEW: "Store/1/TransactionSummaryNew",
//   TRANSACTION_SUMMARY_EXCEL: "/Store/1/TransactionSummaryExcel",

//   // Cashier Setup api's
//   GET_SELECTED_METHODS: "V3/PaymentMethod",
//   GET_ALL_METHODS: "Store/1/PaymentMethods",
//   UPDATE_METHODS: "Store/1/SetPaymentMethods",
//   ORDER_FROM: "Store/1/POSOrderFrom",
//   UPDATE_ORDER_FROM: "Store/1/UpdatePOSOrderFrom",
//   UPDATE_USER_RIGHTS: "/Store/1/UpdateReatilerUserRights",

//   // forLandingPage
//   TALK_TO_SALES: "/Store/1/TalkToSales",

//   //Sidebar
//   SIDEBAR: "/Store/1/GetStoresMenus",
//   // User Access Management 

//   GET_STORE_MENUS: "/Store/1/GetStoresMenus",
//   GET_STORE_USER_MENUS: "/Store/1/GetStoreUserMenus",
//   UPDATE_STORE_USER_MENUS: "/Store/1/UpdateStoreUserMenus"


// };
